import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

(function () {
  appointmentList.$inject = ["ADMIN_URL", "API_URL", "$http", "$q", "$rootScope", "$location"];
  angular.module('userApp').directive('appointmentList', appointmentList);

  function appointmentList(ADMIN_URL, API_URL, $http, $q, $rootScope, $location) {
    return {
      restrict: 'EA',
      templateUrl: ADMIN_URL + '/templates/directives/appointment-list.html',
      replace: true,
      scope: {
        viewAppointments: '=',
        updateParent: '=',
        controllerScope: '='
      },
      link: function link(scope, elem, attrs) {
        scope.selectedAppts = [];
        scope.listScope = scope;
        scope.settings = {
          actionAll: true,
          sendcancellationmeails: true,
          refundcredits: true
        };
        $('.appointment-row').removeClass('highlighted');

        scope.viewAppointments = function (timeslot, shift) {
          scope.shift = shift;
          scope.timeslot = timeslot;
          scope.waitlist = timeslot.waitlist;
          scope.calendarSettings = $rootScope.calendarSettings;
          scope.appointments = _toConsumableArray(timeslot.appointments);
          scope.selectedAppts = [];
          scope.viewingAppointment = false;
          scope.showSavebutton = false;
          scope.showEditButton = false;
          scope.appointments.forEach(function (appt) {
            if (appt.paymentinfo && appt.paymentinfo.type === 'CREDIT') scope.paidByCredit = true; // Whether to show option to refund credits on appointment delete

            if (appt.paymentinfo && appt.paymentinfo.type !== 'NONE') scope.hasPaymentInfo = true; // Whether to show payment info in appointment list
          });
          $('.appointment-row').removeClass('highlighted');
          $('.view-appointments-modal').modal('show');
        };

        scope.toggleSelection = function (appointment) {
          if (appointment.reserved) {
            scope.reservedAppointment = true;
          }

          var found = false,
              index = 0;

          for (var i = 0; i < scope.selectedAppts.length; i++) {
            if (scope.selectedAppts[i]._id === appointment._id) {
              index = i;
              found = true;
              break;
            }
          }

          if (!found) {
            scope.selectedAppts.push(appointment);
            $('.appt-row-' + appointment._id).addClass('highlighted');
          } else {
            scope.selectedAppts.splice(index, 1);
            $('.appt-row-' + appointment._id).removeClass('highlighted');
          }
        };

        scope.moveSelected = function () {
          scope.controllerScope.movingAppts = scope.selectedAppts.slice(); // Necessary to assign the appointments being moved to $rootScope so that they are retained if the page
          // is changed to that of another resource.

          $rootScope.movingAppointments = scope.selectedAppts.slice();
          scope.selectedAppts = [];
          scope.reservedAppointment = false;
          $('.view-appointments-modal').modal('hide');
        }; // The delete function below deletes appointments individually, this function
        // is for deleting all the appointments in a workshop.


        scope.deleteWorkshop = function () {
          if (!confirm(scope.settings.actionAll ? 'This will delete all of the appointments for this workshop for these customers. Continue?' : 'Delete appointment?')) return; // Workshop api is causing problems with reserved appointments, handle those individually

          var reservedAppointments = [],
              customerAppointments = [];
          scope.selectedAppts.forEach(function (appt) {
            appt.reserved ? reservedAppointments.push(appt) : customerAppointments.push(appt);
          });
          var promises = reservedAppointments.map(function (reserved) {
            return $http.delete("".concat(API_URL, "/api/v1/appointments/manage/delete/").concat(reserved._id));
          });
          var payload = {
            actionall: scope.settings.actionAll,
            appointments: customerAppointments,
            sendcancellationemails: scope.settings.sendcancellationmeails
          };

          if (customerAppointments.length) {
            promises.push($http.put(API_URL + '/api/v1/appointments/manage/deleteworkshop', payload));
          }

          Promise.all(promises).then(function (result) {
            // Notify people on the waitlist if a place has become available
            if (scope.waitlist && scope.waitlist.waitlistcustomers.length) {
              $http.get("".concat(API_URL, "/api/v1/waitlist/notify/").concat(scope.waitlist._id)).then(function (result) {
                scope.selectedAppts = [];
                scope.reservedAppointment = false;
                $('.view-appointments-modal').modal('hide');
                scope.updateParent();
              }).catch(function (error) {
                console.error(error); // !!! TODO
              });
            } else {
              scope.selectedAppts = [];
              scope.reservedAppointment = false;
              $('.view-appointments-modal').modal('hide');
              scope.updateParent();
            }
          }).catch(function (error) {
            console.error(error);
            $rootScope.throbber.showError('Sorry but an error has occurred. Please contact support@smoothbook.co if this problem re-occurs');
          });
        };

        scope.deleteSelected =
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var toDelete, results;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (confirm('Please confirm you would like to delete ' + (scope.selectedAppts.length > 1 ? 'these ' + scope.selectedAppts.length + ' appointments' : 'this appointment'))) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  toDelete = scope.selectedAppts.map(function (appt) {
                    return appt._id;
                  });
                  _context.prev = 3;
                  _context.next = 6;
                  return $http.put(API_URL + '/api/v1/appointments/manage/bulkdelete/', {
                    appointments: toDelete,
                    sendemails: scope.settings.sendcancellationmeails,
                    refundcredits: scope.settings.refundcredits
                  });

                case 6:
                  results = _context.sent;
                  scope.selectedAppts = [];
                  scope.reservedAppointment = false;
                  $('.view-appointments-modal').modal('hide');
                  scope.updateParent();
                  _context.next = 16;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](3);
                  console.error(_context.t0.message);

                case 16:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[3, 13]]);
        }));

        scope.deleteSelectedOld = function () {
          if (!confirm('Please confirm you would like to delete ' + (scope.selectedAppts.length > 1 ? 'these ' + scope.selectedAppts.length + ' appointments' : 'this appointment'))) {
            return;
          }

          var promises = [];
          scope.selectedAppts.forEach(function (appointment) {
            promises.push($http.delete(API_URL + '/api/v1/appointments/manage/delete/' + appointment._id));
          });
          $q.all(promises).then(function (results) {
            // Remove selected appointments from the appointments array
            scope.appointments = scope.appointments.filter(function (appointment) {
              for (var i = 0; i < scope.selectedAppts.length; i++) {
                if (scope.selectedAppts[i]._id === appointment._id) return true;
              }

              return false;
            }); // Notify people on the waitlist if a place has become available

            if (scope.waitlist && scope.waitlist.waitlistcustomers.length) {
              $http.get("".concat(API_URL, "/api/v1/waitlist/notify/").concat(scope.waitlist._id)).then(function (result) {
                scope.selectedAppts = [];
                scope.reservedAppointment = false;
                $('.view-appointments-modal').modal('hide');
                scope.updateParent();
              }).catch(function (error) {
                console.error(error); // !!! TODO
              });
            } else {
              scope.selectedAppts = [];
              scope.reservedAppointment = false;
              $('.view-appointments-modal').modal('hide');
              scope.updateParent();
            }
          }).catch(function (error) {
            console.error(error);
            $rootScope.throbber.showError("Sorry but an error occurred: ".concat(error.data, ". Please contact support@smoothbook.co if this problem persists"));
            $('.view-appointments-modal').modal('hide');
            scope.updateParent();
          });
        };

        scope.cancelAppointment = function (appointmentID) {
          $http.delete(API_URL + '/api/v1/appointments/manage/delete/' + appointmentID).then(function (reply) {
            // Update the display.
            for (var i = 0; i < scope.appointments.length; i++) {
              if (appointmentID === scope.appointments[i]._id) {
                scope.appointments.splice(i, 1);
                break;
              }
            }

            if (scope.appointments.length < 1) {
              $('.view-appointments-modal').modal('hide');
            }

            scope.updateParent();
          });
        };

        scope.showAppointment = function (appointmentID) {
          scope.viewingAppointment = true;
          scope.viewAppointment(appointmentID);
        };

        scope.showList = function () {
          scope.viewingAppointment = false;
          scope.showSavebutton = false;
          scope.showEditButton = false;
        };

        scope.viewCustomer = function (customerID) {
          $('.view-appointments-modal').modal('hide');
          $('body').removeClass('modal-open');
          $('.modal-backdrop').remove();
          $location.path('/customer/' + customerID);
        };
      }
    };
  }
})();